import { setYear } from "date-fns";
import type { Plan } from "~/types/entities/finance";
import type { BillingHistoryItem, SavedCard } from "~/types/finance";

export async function fakeAPICall() {
  await new Promise((resolve) => setTimeout(resolve, 1000));
}

export const fakeCards: SavedCard[] = [
  {
    id: "1",
    cardNumber: "1234 5678 9012 3456",
    holderName: "mastercard",
    expiryDate: "12/22",
    cvv: "123",
    billingAddress: {
      country: "United States",
      city: "San Francisco",
      address: "123 Main St",
      zipCode: "94111",
    },
  },
  {
    id: "2",
    cardNumber: "1234 5678 9012 3456",
    holderName: "visa",
    expiryDate: "12/22",
    cvv: "123",
    billingAddress: {
      country: "United States",
      city: "San Francisco",
      address: "123 Main St",
      zipCode: "94111",
    },
  },
];

export const fakePlans: Plan[] = [
  {
    id: "plan_basic_001",
    createdAt: "2025-01-10T12:00:00Z",
    updatedAt: "2025-01-10T12:00:00Z",
    deletedAt: null,
    name: "Basic Plan",
    description: "Ideal for individuals starting out with essential features.",
    features: ["Access to core tools", "Email support", "5GB cloud storage"],
    level: "basic",
    monthsPerInterval: 1,
    prices: [
      {
        id: "price_basic_usd",
        amount: 9.99,
        currencyId: "USD",
        currencyName: "US Dollar",
      },
      {
        id: "price_basic_ngn",
        amount: 9500,
        currencyId: "NGN",
        currencyName: "Nigerian Naira",
      },
    ],
  },
  {
    id: "plan_pro_002",
    createdAt: "2025-01-10T12:00:00Z",
    updatedAt: "2025-01-10T12:00:00Z",
    deletedAt: null,
    name: "Pro Plan",
    description:
      "For professionals who need advanced analytics and priority support.",
    features: [
      "Everything in Basic",
      "Advanced analytics dashboard",
      "Priority email and chat support",
      "50GB cloud storage",
    ],
    level: "pro",
    monthsPerInterval: 3,
    prices: [
      {
        id: "price_pro_usd",
        amount: 24.99,
        currencyId: "USD",
        currencyName: "US Dollar",
      },
      {
        id: "price_pro_ngn",
        amount: 23500,
        currencyId: "NGN",
        currencyName: "Nigerian Naira",
      },
    ],
  },
  {
    id: "plan_business_003",
    createdAt: "2025-01-10T12:00:00Z",
    updatedAt: "2025-01-10T12:00:00Z",
    deletedAt: null,
    name: "Business Plan",
    description:
      "Perfect for small teams that require integrations and collaboration tools.",
    features: [
      "Everything in Pro",
      "Team management and roles",
      "API access",
      "Custom reports",
      "200GB cloud storage",
    ],
    level: "business",
    monthsPerInterval: 6,
    prices: [
      {
        id: "price_business_usd",
        amount: 59.99,
        currencyId: "USD",
        currencyName: "US Dollar",
      },
      {
        id: "price_business_ngn",
        amount: 56500,
        currencyId: "NGN",
        currencyName: "Nigerian Naira",
      },
    ],
  },
  {
    id: "plan_enterprise_004",
    createdAt: "2025-01-10T12:00:00Z",
    updatedAt: "2025-01-10T12:00:00Z",
    deletedAt: null,
    name: "Enterprise Plan",
    description:
      "For large organizations needing custom solutions, SLAs, and dedicated support.",
    features: [
      "Everything in Business",
      "Dedicated account manager",
      "Custom integrations",
      "Uptime SLA",
      "Unlimited cloud storage",
    ],
    level: "enterprise",
    monthsPerInterval: 12,
    prices: [
      {
        id: "price_enterprise_usd",
        amount: 149.99,
        currencyId: "USD",
        currencyName: "US Dollar",
      },
      {
        id: "price_enterprise_ngn",
        amount: 142000,
        currencyId: "NGN",
        currencyName: "Nigerian Naira",
      },
    ],
  },
];

export const fakeBillingHistory: BillingHistoryItem[] = [
  {
    description: "Subscription Fee",
    date: "March 13,2023",
    servicePeriod: "March 13,2023-Mar 13,2024",
    paymentMethod: "Verve card",
    plan: "Popular",
    amount: "$29.00",
  },
  {
    description: "Subscription Fee",
    date: "March 13,2023",
    servicePeriod: "March 13,2023-Mar 13,2024",
    paymentMethod: "Verve card",
    plan: "Popular",
    amount: "$29.00",
  },
  {
    description: "Subscription Fee",
    date: "March 13,2023",
    servicePeriod: "March 13,2023-Mar 13,2024",
    paymentMethod: "Verve card",
    plan: "Popular",
    amount: "$29.00",
  },
  {
    description: "Subscription Fee",
    date: "March 13,2023",
    servicePeriod: "March 13,2023-Mar 13,2024",
    paymentMethod: "Verve card",
    plan: "Popular",
    amount: "$29.00",
  },
  {
    description: "Subscription Fee",
    date: "March 13,2023",
    servicePeriod: "March 13,2023-Mar 13,2024",
    paymentMethod: "Verve card",
    plan: "Popular",
    amount: "$29.00",
  },
];
